import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BackArrow from '../assets/images/Frame_18177.png';
import InactivityTimer from '../components/InactivityTimer';

// Example JSON data
const faqData = [
    {
        id: 1,
        heading: "Q1. Who is eligible for treatment in this Hospital?",
        content: "All patients, irrespective of age, gender, or background, are eligible for treatment. Emergency cases are attended immediately. OPD and IPD services are available for both registered and walk-in patients."
    },
    {
        id: 2,
        heading: "Q2. What kind of facilities are available in the Hospital?",
        content: `The hospital provides the following facilities:
- Outpatient Department (OPD)
- Inpatient Admission (IPD)
- Laboratory & Diagnostic Services
- Radiology (X-Ray, CT, MRI, Ultrasound)
- Emergency & Trauma Care
- Pharmacy
- Blood Bank
- Operation Theatres with advanced equipment
- ICU / NICU / PICU
- Billing & Insurance/TPA support`
    },
    {
        id: 3,
        heading: "Q3. What are the OPD timings?",
        content: `
- General OPD: 9:00 AM to 5:00 PM (Monday–Saturday)
- Specialty OPD: As per doctor's schedule
- Emergency Services: 24×7 available`
    },
    {
        id: 4,
        heading: "Q4. Is blood for transfusion available in the Hospital during emergency or operations?",
        content: "Yes. The hospital has an in-house licensed blood bank and ensures availability of blood and components (PRBC, Platelets, FFP) for emergency and surgical cases. Availability is subject to testing and compatibility."
    },
    {
        id: 5,
        heading: "Q5. Whom to contact in case of difficulty?",
        content: `You may contact:
- Help Desk / Information Counter
- Nursing Station (for admitted patients)
- Emergency Reception (for critical cases)`
    },
    {
        id: 6,
        heading: "Q6. How can I book an appointment with a doctor?",
        content: "You can book through the Kiosk, Hospital Website or by visiting the OPD help desk."
    },
    {
        id: 7,
        heading: "Q7. What documents are required for registration?",
        content: "Aadhaar Card, insurance/TPA card, previous medical records, or referral letter (if applicable)."
    },
    {
        id: 8,
        heading: "Q8. How can I get my lab or radiology reports?",
        content: "Reports can be collected from the Lab Reporting Counter or downloaded from the Kiosk, depending on availability."
    },
    {
        id: 9,
        heading: "Q9. Does the hospital accept insurance/TPA?",
        content: "Yes, the hospital accepts multiple insurance and TPA schemes. You can check the approved list at the Insurance Desk."
    },
    {
        id: 10,
        heading: "Q10. What payment modes are accepted?",
        content: "Cash, Debit/Credit Card, UPI, Online Payment, Insurance/TPA (for approved cases)."
    }
];


const Faqs = () => {
    const [openIndex, setOpenIndex] = useState(1);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <InactivityTimer />
            <div className='flex items-center'>
                <Link to="/" className="flex w-28 mt-6 ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200" style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}>
                    <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                    Back
                </Link>
                <span className='mt-8 ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>
                    Frequently Asked Questions
                </span>

                {/* close session button */}
                {/* <Link to="/session-end" className='mr-14 mt-5 ml-auto px-2 py-2 text-white bg-red-600 rounded-lg font-semibold text-[20px]'>
                    Close Session
                </Link> */}
            </div>

            {/* Horizontal Line */}
            <hr className="mt-6 ml-14 mr-14 border-t-1 border-gray-300" />

            <div id="accordion-collapse" className='mt-6 mb-6 ml-14 mr-14'>
                {faqData.map(({ id, heading, content }) => (
                    <div key={id}>
                        <h2 id={`accordion-collapse-heading-${id}`}>
                            <button
                                type="button"
                                className="bg-[#0FA968] flex items-center justify-between w-full p-4 font-medium rtl:text-right text-white border border-b-0 border-gray-200 gap-3"
                                onClick={() => handleToggle(id)}
                                aria-expanded={openIndex === id}
                                aria-controls={`accordion-collapse-body-${id}`}
                            >
                                <span>{heading}</span>
                                {openIndex === id ? (
                                    <svg className="w-3 h-3 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 2">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h8" />
                                    </svg>
                                ) : (
                                    <svg className="w-3 h-3 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1v8M1 5h8" />
                                    </svg>
                                )}
                            </button>
                        </h2>
                        {openIndex === id && (
                            <div id={`accordion-collapse-body-${id}`} className="bg-[#DAFEEF] p-5 border border-b-0 border-gray-200">
                                <p className="mb-2 text-black whitespace-pre-line">
                                    {content}
                                </p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </>
    )
}

export default Faqs;
